module.exports = __webpack_public_path__ + "assets/1c8a942bd5655ca5adffceb31d580895.png";